module.exports = __webpack_public_path__ + "img/dashboard-gpa.be41ecf1.png";